import * as React from 'react';

const SvgLoading = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    data-name="Icon loading"
    {...props}
  >
    <path
      d="M10.534 21a10.043 10.043 0 0 1-7.4-3.288l-1.986-2.133a.736.736 0 0 1 0-.965.617.617 0 0 1 .9 0l1.986 2.134a8.764 8.764 0 0 0 13.006 0 10.2 10.2
0 0 0 2.693-6.986.637.637 0 1 1 1.27 0 11.6 11.6 0 0 1-3.066 7.95A10.043 10.043 0 0 1 10.534 21z"
      data-name="Trac\xE9 139"
    />
    <path
      d="M1.642 20.042a.7.7 0 0 1-.682-.682v-4.267a.7.7 0 0 1 .682-.682h4.267a.682.682 0 0 1 0 1.364H2.324v3.585a.7.7 0 0 1-.682.682z"
      data-name="Trac\xE9 140"
    />
    <path
      d="M.635 11.921A.675.675 0 0 1 0 11.239a11.6 11.6 0 0 1 3.066-7.95 9.972 9.972 0 0 1 14.8 0l1.986 2.133a.736.736 0 0 1 0 .965.617.617 0 0 1-.9 0l-1.986-2.134a8.765 8.765 0 0 0-13.006 0 10.2 10.2 0 0 0-2.69 6.986.675.675 0 0 1-.635.682z"
      data-name="Trac\xE9 141"
    />
    <path
      d="M19.358 6.586h-4.267a.682.682 0 1 1 0-1.364h3.586V1.637a.682.682 0 1 1 1.364 0v4.267a.7.7 0 0 1-.683.682z"
      data-name="Trac\xE9 142"
    />
  </svg>
);
export default SvgLoading;
